import { Paging } from '@elastic/react-search-ui';
import { styled } from '@mui/material';
import theme from '../../constants/theme';

const FooterStyled = styled(Paging)({
  ul: {
    display: 'flex',
    alignItems: 'center',
  },
  'li.rc-pagination-item-active': {
    backgroundColor: theme.palette.primary.main + '!important',
  },
  'li.rc-pagination-item': {
    backgroundColor: theme.palette.secondary.dark,
    height: '38px',
    width: '38px',
    borderRadius: 0,
    fontSize: theme.typography.h6.fontSize,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  'li.rc-pagination-item:hover': {
    backgroundColor: `${theme.palette.secondary.dark} !important`,
  },
  'li.rc-pagination-item-active:hover': {
    backgroundColor: theme.palette.primary.main + '!important',
  },
  '.rc-pagination-item a': {
    color: `${theme.palette.secondary.main} !important`,
    fontWeight: 600,
  },
  'li.rc-pagination-jump-next, li.rc-pagination-jump-prev': {
    position: 'relative',
    top: '12px',
  },
  'li.rc-pagination-jump-next:hover, li.rc-pagination-jump-prev:hover, .sui-paging .rc-pagination-next:hover':
    {
      background: theme.palette.transparent.main,
    },
  '.rc-pagination-jump-prev:after, .rc-pagination-jump-next:after, li.rc-pagination-jump-next:hover > .rc-pagination-jump-prev:after, .rc-pagination-jump-next:after, .rc-pagination-jump-prev:hover:after':
    {
      color: `${theme.palette.text.secondary} !important`,
      fontSize: theme.typography.subtitle2.fontSize,
      lineHeight: 'unset',
    },
  /* < Previous and Next btn > */
  '.rc-pagination-prev a, .rc-pagination-next a': {
    color: '#008C46 !important',
  },
  '.rc-pagination-next a:after, .rc-pagination-prev a:after': {
    transform: 'scale(1.8)',
    display: 'flex',
    justifyContent: 'center',
  },
  'li.rc-pagination-next, li.rc-pagination-prev': {
    position: 'relative',
    top: '6px',
  },
  /* it does not show the arrow btn when is disabled */
  '.rc-pagination-disabled': {
    display: 'none',
  },
});

export default FooterStyled;
